import React, { useState } from 'react';
import useMountedRef from '../../hooks/useMountedRef/useMountedRef.js';
import styles from './RippleButton.module.css.js';

var RippleButton = function RippleButton(_a) {
  var label = _a.label,
      onClick = _a.onClick,
      _b = _a.primary,
      primary = _b === void 0 ? false : _b,
      _c = _a.size,
      size = _c === void 0 ? 'medium' : _c,
      _d = _a.disabled,
      disabled = _d === void 0 ? false : _d,
      id = _a.id,
      _e = _a.type,
      type = _e === void 0 ? 'button' : _e,
      mobileOptimized = _a.mobileOptimized,
      modalOptimized = _a.modalOptimized,
      _f = _a.loading,
      loading = _f === void 0 ? false : _f,
      _g = _a.warning,
      warning = _g === void 0 ? false : _g;

  var _h = useState({
    x: -1,
    y: -1
  }),
      coords = _h[0],
      setCoords = _h[1];

  var _j = useState(false),
      isRippling = _j[0],
      setIsRippling = _j[1];

  var mounted = useMountedRef();

  var timeOutOnClick = function timeOutOnClick(e) {
    setTimeout(function () {
      if (!mounted.current || !onClick) return;
      setIsRippling(false);
      onClick(e);
    }, 200);
  };

  var primaryClass = warning ? 'primary-warning' : 'primary';
  var secondaryClass = warning ? 'secondary-warning' : 'secondary';
  return /*#__PURE__*/React.createElement("button", {
    disabled: loading || isRippling || disabled,
    type: type === 'submit' ? 'submit' : 'button',
    id: id,
    className: [styles["ripple-button"], styles["ripple-button-".concat(size)], styles["ripple-button-default-".concat(primary ? primaryClass : secondaryClass)]].join(' '),
    onClick: function onClick(e) {
      var rect = e.currentTarget.getBoundingClientRect();
      setIsRippling(true);
      setCoords({
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      }); // eslint-disable-next-line @typescript-eslint/no-unused-expressions

      timeOutOnClick(e);
    }
  }, isRippling ? /*#__PURE__*/React.createElement("span", {
    className: styles.ripple,
    style: {
      left: coords.x,
      top: coords.y
    }
  }) : '', /*#__PURE__*/React.createElement("span", {
    className: [mobileOptimized ? styles['ripple-button-mobile-optimized'] : '', modalOptimized ? styles['ripple-button-modal-optimized'] : ''].join(' ')
  }, loading ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    className: styles['loader-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: [styles.loader, styles["loader-".concat(primary ? primaryClass : secondaryClass)], styles["loader-".concat(size)]].join(' ')
  }))) : /*#__PURE__*/React.createElement("div", null, label)));
};

export { RippleButton };
//# sourceMappingURL=RippleButton.js.map
